__turbopack_context__.v({
  "className": "inter_22094684-module__29r1Fa__className",
  "variable": "inter_22094684-module__29r1Fa__variable",
});
